import Vue from 'vue';

export class X3tech{

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static byPK(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('configuracao-x3tech/by-pk/' + idRastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static sendTempos(json){
        return Vue.http.post('configuracao-x3tech/times', json);
    }

    static sendSleep(json){
        return Vue.http.post('configuracao-x3tech/sleep', json);
    }

    static sendHbt(json){
        return Vue.http.post('configuracao-x3tech/hbt', json);
    }

    static sendApn(json){
        return Vue.http.post('configuracao-x3tech/apn', json);
    }

    static sendIp(json){
        return Vue.http.post('configuracao-x3tech/ip', json);
    }

    static sendIpAll(json){
        return Vue.http.post('configuracao-x3tech/ip/all', json);
    }

    static sendFiltro(json){
        return Vue.http.post('configuracao-concox/filtro', json);
    }

}
